export default "__VITE_PUBLIC_ASSET__66adcdcd__"